import { observable, action, decorate } from 'mobx';

import * as tiaoApi from '../../apis/TiaoApi';

export default class TiaoStore {
  html = {
    header: '',
    footer: '',
  };

  getHtml = async component => {
    const { data } = await tiaoApi.getHtml(`external-${component}.html`);
    this.html[component] = data;
  };
}

decorate(TiaoStore, {
  html: observable,
  getHtml: action,
});

const tiaoStore = new TiaoStore();

export { tiaoStore };
